export class NBNHardware {
  constructor(
    id,
    hardwareName,
    contractLength,
    usageType,
    detail,
    rrp,
    archive = false
  ) {
    this.id = id;
    this.hardwareName = hardwareName;
    this.contractLength = contractLength;
    this.usageType = usageType || 'nbn';
    this.detail = detail;
    this.rrp = rrp;
    this.archive = archive;
  }
}

export function CreatenewNBNHardware(data) {
  return Object.freeze(new NBNHardware(data));
}
